import {LocaleContext} from "../store/providers/LocaleProvider";
import {useContext} from "react";
import {useLogger} from "./useLogger";
import {gql, useQuery} from "@apollo/client";

const QUERY = gql`
query getInfoBannerTrial($locale: String!){
    htmlComponentsCollection(
        limit : 1,
        where: { type: "info_banner"}
        locale: $locale
    ) {
        items {
            backgroundColour
            elementsCollection{
                items{
                    ...on TextColumnsWithImage{
                        image{
                            title
                            url
                        }
                        title
                        subtitle
                        description
                        ctaLinksCollection{
                            items{
                                ...on Button{
                                    url
                                    type
                                    label
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}`;

export const useInfoBannerTrial = () => {
    const {logger} = useLogger();
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {loading, data, error} = useQuery(QUERY, {variables: { locale: localeUppercase}, errorPolicy: "all"});

    const componentData = data?.htmlComponentsCollection;

    if(error?.message) {
        logger(error?.message, "error", "useInfoBannerTrial", error?.stack);
    }
    return {
        componentData,
        loading,
        error
    };
};
